'use client';
import Link from 'next/link';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const navItems = [
  { label: 'Home', href: '/' },
  { label: 'World', href: '/world' },
  { label: 'Politics', href: '/world' },
  { label: 'Business', href: '/world' },
  { label: 'Technology', href: '/world' },
  { label: 'Climate', href: '/world' },
  { label: 'Opinion', href: '/opinion' },
  { label: 'Culture', href: '/world' },
  { label: 'Sport', href: '/world' },
  { label: 'Video', href: '/video' },
  { label: '🔴 Live Updates', href: '/live' },
  { label: 'Latest & Most Read', href: '/latest' },
  { label: 'Newsletters', href: '/newsletters' },
  { label: 'About', href: '/about' },
];

export default function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[300] bg-[#1A1A1A] overflow-y-auto">
      <div className="px-5 py-4 flex items-center justify-between border-b border-[#333333]">
        <Link href="/" onClick={onClose} className="flex items-end gap-0">
          <span className="bg-[#C8102E] text-white font-['Playfair_Display',Georgia,serif] font-black text-[20px] px-3 py-1.5 leading-none">
            VERITAS
          </span>
          <span className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[9px] tracking-[0.18em] text-[#6B6B6B] uppercase ml-2 pb-0.5">
            NEWS
          </span>
        </Link>
        <button
          onClick={onClose}
          className="text-white text-2xl font-light p-2 leading-none"
          aria-label="Close menu"
        >
          ✕
        </button>
      </div>
      <nav className="px-5 pt-2 pb-8">
        {navItems.map((item) => (
          <Link
            key={item.label}
            href={item.href}
            onClick={onClose}
            className="block text-[#CCCCCC] text-[16px] font-['IBM_Plex_Sans',system-ui,sans-serif] font-medium py-3.5 border-b border-[#333333] hover:text-white transition-colors"
          >
            {item.label}
          </Link>
        ))}
      </nav>
      <div className="px-5 pb-8 pt-2">
        <Link
          href="/newsletters"
          onClick={onClose}
          className="block w-full bg-[#C8102E] text-white text-center font-['IBM_Plex_Sans',system-ui,sans-serif] font-semibold text-[14px] py-3 hover:bg-[#9E0C23] transition-colors"
        >
          Subscribe Free
        </Link>
      </div>
    </div>
  );
}
